


import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { UiformBaseComponent } from '../uiform-base/uiform-base.component';
import { ServiceLocatorService } from '@ncs/ncs-lib';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

interface ChatMessage {
  type: 'user' | 'ai';
  content: any;
  timestamp: string;
}

@Component({
  selector: 'app-ai-report',
  templateUrl: './ai-report.component.html',
  styleUrls: ['./ai-report.component.scss'],
})
export class AiReportComponent extends UiformBaseComponent {
  userInput: string = '';
  chatMessages: ChatMessage[] = [];
  isLoading: boolean = false;

  @ViewChild('chatHistory') private chatHistory!: ElementRef;

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private sanitizer: DomSanitizer
  ) {
    super(locator, route);
    if (route.snapshot.paramMap.get('id')) {
      this.uiformId = Number(route.snapshot.paramMap.get('id'));
    }
  }

  sendMessage(): void {
    if (!this.userInput.trim() || this.isLoading) return;

    const userMessage: ChatMessage = {
      type: 'user',
      content: this.userInput,
      timestamp: this.getCurrentTime(),
    };

    this.chatMessages.push(userMessage);

    const userInput = this.userInput;
    this.userInput = '';
    this.isLoading = true;

    this.cdRef.detectChanges();
    this.scrollToBottom();

    this.callChatAPI(userInput);
  }

  // private async callChatAPI(userInput: string) {
  //   let url = await this.locator.getEndpoint('endpoint.aichat');

  //   const payload = {
  //     prompt: userInput,
  //     collection: this.usecase['collectionName'],
  //     usecaseId: this.usecaseId,
  //   };

  //   this.locator.http.post(url, payload, (res: any, error: boolean) => {
  //     if (error) {
  //       this.handleError('Server Error: ' + error);
  //       return;
  //     }

  //     this.form.error = !res.success;
  //     this.form.message = res.message;

  //     if (res.success) {
  //       this.handleApiResponse(res, userInput);
  //     } else {
  //       this.handleError(res.message || 'Unknown error occurred');
  //     }
  //   });
  // }

  private async callChatAPI(userInput: string) {
    const url = await this.locator.getEndpoint('endpoint.aichat');

    const payload = {
      prompt: userInput,
      collection: this.usecase['collectionName'],
      usecaseId: this.usecaseId,
    };

    this.locator.http.post(url, payload, (res: any, error: boolean) => {
      if (error) {
        this.handleError('Server Error: ' + error);
        return;
      }

      // ❌ DO NOT check res.success here
      // ❌ DO NOT assume JSON

        this.handleApiResponse(res, userInput);
    });
  }

  private convertToHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
  private has70PercentColumns(columns: any[], row: any): boolean {
  const total = columns.length;
  let present = 0;

  columns.forEach(col => {
    if (row.hasOwnProperty(col)) present++;
  });

  // check 70%
  return (present / total) >= 0.7;
}

private isFullRow(columns: any[], row: any): boolean {
  return columns.every(col => row.hasOwnProperty(col));
}

  // private handleApiResponse(res: any, userInput: any): void {
  //   let aiResponse = '';

  //   console.log("response : ",res);
  //   console.log(userInput);

  //   // ----------- TABLE DETECTION ---------------
  //   if (
  //     res.result &&
  //     res.result.columns &&
  //     res.result.results &&
  //     res.result.results.length > 0 &&
  //     this.has70PercentColumns(res.result.columns, res.result.results[0])
  //   ) {
  //     aiResponse += `<div class="ai-response-content">`;

  //     if (res.result.summary) {
  //       aiResponse += `<div class="ai-summary mb-3">
  //         <p class="mb-0"><strong>Summary:</strong> ${res.result.summary}</p>
  //       </div>`;
  //     }

  //     aiResponse += `<div class="table-responsive">
  //       <table class="ai-data-table table table-striped table-bordered table-hover">
  //         <thead class="table-header">
  //           <tr>`;

  //     // Table Header
  //     res.result.columns.forEach((col: any) => {
  //       aiResponse += `<th scope="col">${this.escapeHtml(col)}</th>`;
  //     });

  //     aiResponse += `</tr>
  //         </thead>
  //         <tbody>`;

  //     // Table Rows
  //     res.result.results.forEach((row: any, index: number) => {
  //       aiResponse += `<tr class="${index % 2 === 0 ? 'even-row' : 'odd-row'}">`;
  //       res.result.columns.forEach((col: any) => {
  //         const cellValue = row[col] ?? '';
  //         aiResponse += `<td>${this.escapeHtml(cellValue.toString())}</td>`;
  //       });
  //       aiResponse += `</tr>`;
  //     });

  //     aiResponse += `</tbody>
  //       </table>
  //     </div>`;

  //     aiResponse += `<div class="table-info mt-2">
  //       <small class="text-muted">Showing ${res.result.results.length} record(s)</small>
  //     </div>`;

  //     aiResponse += `</div>`;

  //   } else {
  //     // Normal text fallback
  //     aiResponse = `<div class="ai-text-response">${this.escapeHtml(res?.result?.summary || res?.message || 'No response found.')}</div>`;
  //   }

  //   const aiMessage: ChatMessage = {
  //     type: 'ai',
  //     content: this.convertToHtml(aiResponse),
  //     timestamp: this.getCurrentTime(),
  //   };

  //   this.chatMessages.push(aiMessage);
  //   this.isLoading = false;

  //   this.cdRef.detectChanges();
  //   this.scrollToBottom();
  // }

  // private handleApiResponse(res: any, userInput: any): void {
  //   let aiResponse = '';

  //   console.log('response : ', res);
  //   console.log('userInput : ', userInput);

  //   // ----------- TABLE OR HTML DETECTION ---------------
  //   if (res.result?.summary_html) {
  //     // If API returns prebuilt HTML (table or formatted summary)
  //     aiResponse = `<div class="ai-response-content">${res.result.summary_html}</div>`;
  //   } else if (
  //     res.result &&
  //     res.result.columns &&
  //     res.result.results &&
  //     res.result.results.length > 0 &&
  //     this.has70PercentColumns(res.result.columns, res.result.results[0])
  //   ) {
  //     // Build table manually if columns & results exist
  //     aiResponse += `<div class="ai-response-content">`;

  //     if (res.result.summary) {
  //       aiResponse += `<div class="ai-summary mb-3">
  //       <p class="mb-0"><strong>Summary:</strong> ${this.escapeHtml(
  //         res.result.summary
  //       )}</p>
  //     </div>`;
  //     }

  //     aiResponse += `<div class="table-responsive">
  //     <table class="ai-data-table table table-striped table-bordered table-hover">
  //       <thead class="table-header">
  //         <tr>`;
  //     res.result.columns.forEach((col: any) => {
  //       aiResponse += `<th scope="col">${this.escapeHtml(col)}</th>`;
  //     });
  //     aiResponse += `</tr>
  //       </thead>
  //       <tbody>`;
  //     res.result.results.forEach((row: any, index: number) => {
  //       aiResponse += `<tr class="${
  //         index % 2 === 0 ? 'even-row' : 'odd-row'
  //       }">`;
  //       res.result.columns.forEach((col: any) => {
  //         const cellValue = row[col] ?? '';
  //         aiResponse += `<td>${this.escapeHtml(cellValue.toString())}</td>`;
  //       });
  //       aiResponse += `</tr>`;
  //     });
  //     aiResponse += `</tbody></table></div>`;
  //     aiResponse += `<div class="table-info mt-2">
  //     <small class="text-muted">Showing ${res.result.results.length} record(s)</small>
  //   </div>`;
  //     aiResponse += `</div>`;
  //   } else {
  //     // Normal text fallback
  //     aiResponse = `<div class="ai-text-response">${this.escapeHtml(
  //       res?.result?.summary || res?.message || 'No response found.'
  //     )}</div>`;
  //   }

  //   const aiMessage: ChatMessage = {
  //     type: 'ai',
  //     content: this.convertToHtml(aiResponse),
  //     timestamp: this.getCurrentTime(),
  //   };

  //   this.chatMessages.push(aiMessage);
  //   this.isLoading = false;

  //   this.cdRef.detectChanges();
  //   this.scrollToBottom();
  // }

  // private handleApiResponse(res: any, userInput: any): void {
  //   let aiResponse!: SafeHtml;

  //   const result = res;
  //   const data = result?.data;

  //   console.log('API response:', res);

  //   /* ============================
  //    1️⃣ SVG RESPONSE
  // ============================ */
  //   if (data?.content_type === 'summary') {
  //     aiResponse = this.sanitizer.bypassSecurityTrustHtml(`
  //     <div class="ai-response-content text-center">
  //       <div class="svg-container">
  //         ${data}
  //       </div>
  //     </div>
  //   `);
  //   } else if (data?.content_type === 'table') {
  //     /* ============================
  //    2️⃣ TABLE RESPONSE
  // ============================ */
  //     aiResponse = this.sanitizer.bypassSecurityTrustHtml(`
  //     <div class="ai-response-content">
  //       <div class="table-responsive">
  //         ${data.summary_html}
  //       </div>
  //       <div class="table-info mt-2">
  //         <small class="text-muted">
  //           Showing ${data.results_count || 0} record(s)
  //         </small>
  //       </div>
  //     </div>
  //   `);
  //   } else  {
  //     /* ============================
  //    3️⃣ TEXT RESPONSE
  // ============================ */
  //     const summary = data?.summary || res?.message || 'No response found.';

  //     aiResponse = this.sanitizer.bypassSecurityTrustHtml(`
  //     <div class="ai-text-response">
  //       ${this.escapeHtml(summary)}
  //     </div>
  //   `);
  //   }

  //   /* ============================
  //    PUSH MESSAGE
  // ============================ */
  //   const aiMessage: ChatMessage = {
  //     type: 'ai',
  //     content: aiResponse, // ✅ NO convertToHtml
  //     timestamp: this.getCurrentTime(),
  //   };

  //   this.chatMessages.push(aiMessage);
  //   this.isLoading = false;

  //   this.cdRef.detectChanges();
  //   this.scrollToBottom();
  // }

private handleApiResponse(res: any, userInput: any): void {
    let aiResponse!: SafeHtml;

    // Identify the content type from your specific JSON structures
    const isSvg = res.type === 'svg' || res.contentType === 'image/svg+xml';
    const isTable = res.data?.content_type === 'table';

    console.log('Processing API response:', res);
    
    /* ============================
     1️⃣ SVG RESPONSE
  ============================ */
    if (isSvg) {
      // The SVG XML is in res.data
      aiResponse = this.sanitizer.bypassSecurityTrustHtml(`
      <div class="ai-response-content text-center">
        <div class="svg-container" style="max-width: 100%; overflow-x: auto;">
          ${res.data}
        </div>
      </div>
    `);
    } else if (isTable) {
    /* ============================
     2️⃣ TABLE RESPONSE
  ============================ */
      aiResponse = this.sanitizer.bypassSecurityTrustHtml(`
      <div class="ai-response-content">
        <div class="table-responsive">
          ${res.data.summary_html}
        </div>
        <div class="table-info mt-2">
          <small class="text-muted">
            Showing ${res.data.results_count || 0} record(s)
          </small>
        </div>
      </div>
    `);
    } else {
    /* ============================
     3️⃣ TEXT / SUMMARY RESPONSE
  ============================ */
      // Access the specific string field to avoid [object Object]
      const summaryText =
        res.data?.summary || res?.message || 'No response found.';

      aiResponse = this.sanitizer.bypassSecurityTrustHtml(`
      <div class="ai-text-response">
        ${this.escapeHtml(summaryText)}
      </div>
    `);
  }

    /* ============================
     PUSH MESSAGE
  ============================ */
  const aiMessage: ChatMessage = {
    type: 'ai',
      content: aiResponse,
    timestamp: this.getCurrentTime(),
  };

  this.chatMessages.push(aiMessage);
  this.isLoading = false;
  this.cdRef.detectChanges();
  this.scrollToBottom();
}

  private createBlobUrl(base64: string, mimeType: string): string {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });

    return URL.createObjectURL(blob);
  }

  private escapeHtml(unsafe: string): string {
    return unsafe
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  private handleError(errorMessage: string): void {
    const errorResponse: ChatMessage = {
      type: 'ai',
      content: `I encountered an error: ${errorMessage}. Please try again.`,
      timestamp: this.getCurrentTime(),
    };

    this.chatMessages.push(errorResponse);
    this.isLoading = false;

    this.cdRef.detectChanges();
    this.scrollToBottom();
  }

  clearChat(): void {
    this.chatMessages = [];
    this.userInput = '';
  }

  private getCurrentTime(): string {
    return new Date().toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    });
  }

  private scrollToBottom(): void {
    try {
      setTimeout(() => {
        this.chatHistory.nativeElement.scrollTop =
          this.chatHistory.nativeElement.scrollHeight;
      }, 100);
    } catch (err) {
      console.error('Scroll error:', err);
    }
  }
}
